import React from 'react';
import styled from 'styled-components';
import LazyLoadedImg from 'core/components/LazyLoadedImg';

export const Figure = styled.figure`
	position: relative;
	overflow: hidden;
`;

export const Img = styled(LazyLoadedImg)`
	display: block;
	width: 100%;
	height: 100%;
	object-fit: cover;
	transition: 0.5s;
	transform-origin: center;

	&:hover, &:active {
		transform: scale(1.05);
	}
`;

// To style style the figure element from the parent element :nailcare:
const FancyHoverImg = props => (
	<Figure>
		<Img {...props} />
	</Figure>
);

export default FancyHoverImg;
